import { AllTShirtMeasuresMandatory, TeeMeasureLabel } from "../types/databaseTables/idealteemeasures";

export interface MeasureProps {
	name: string;
	min: number;
	max: number;
	imageRef: string;
}
export interface TeesPropertiesBooleansObject {
	chest: boolean,
	waist: boolean,
	hem: boolean,
	frontlength: boolean,
	neckwidth: boolean,
	necktoshoulder: boolean,
	shouldertoshoulder: boolean,
	sleevelength: boolean,
	armholeopening: boolean,
	sleeveopening: boolean,
}

export const teesPropertiesBooleansObject: TeesPropertiesBooleansObject = {
	chest: false,
	waist: false,
	hem: false,
	frontlength: false,
	neckwidth: false,
	necktoshoulder: false,
	shouldertoshoulder: false,
	sleevelength: false,
	armholeopening: false,
	sleeveopening: false,
};

export const teesPropertiesBooleansObjectTrue: TeesPropertiesBooleansObject = {
	chest: true,
	waist: true,
	hem: true,
	frontlength: true,
	neckwidth: true,
	necktoshoulder: true,
	shouldertoshoulder: true,
	sleevelength: true,
	armholeopening: true,
	sleeveopening: true,
};

export const teesPropertiesObject: Record<TeeMeasureLabel, MeasureProps> = {
	chest: {
		name: "Chest",
		min: 40,
		max: 100,
		imageRef: "/img/tshirt-chest.png",
	},
	waist: {
		name: "Waist",
		min: 40,
		max: 100,
		imageRef: "/img/tshirt-waist.png",
	},
	hem: {
		name: "Hem",
		min: 40,
		max: 100,
		imageRef: "/img/tshirt-hem.png",
	},
	frontlength: {
		name: "Front Length",
		min: 60,
		max: 100,
		imageRef: "/img/tshirt-frontlength.png",
	},
	neckwidth: {
		name: "Neck width",
		min: 12,
		max: 25,
		imageRef: "/img/tshirt-neckwidth.png",
	},
	necktoshoulder: {
		name: "Neck to Shoulder",
		min: 10,
		max: 50,
		imageRef: "/img/tshirt-necktoshoulder.png",
	},
	shouldertoshoulder: {
		name: "Shoulder to Shoulder",
		min: 40,
		max: 70,
		imageRef: "/img/tshirt-shouldertoshoulder.png",
	},
	sleevelength: {
		name: "Sleeve Length",
		min: 5,
		max: 40,
		imageRef: "/img/tshirt-sleevelength.png",
	},
	armholeopening: {
		name: "Arm Hole Opening",
		min: 15,
		max: 30,
		imageRef: "/img/tshirt-armholeopening.png",
	},
	sleeveopening: {
		name: "Sleeve Opening",
		min: 15,
		max: 40
		,
		imageRef: "/img/tshirt-sleevewidth.png",
	},
};

export const arrayOfMeasureLabels = Object.keys(teesPropertiesObject)


export const initialTeeMeasuresAveragesState = Object.keys(teesPropertiesObject).reduce((acc, cur) => {
	acc[cur as keyof typeof initialTeeMeasuresAveragesState] = 0;
	return acc;
}, {} as AllTShirtMeasuresMandatory);

export interface AllTShirtMeasuresOptional {
	frontlength?: number;
	shouldertoshoulder?: number;
	chest?: number;
	waist?: number;
	hem?: number;
	armholeopening?: number;
	neckwidth?: number;
	sleeveopening?: number;
	sleevelength?: number;
	necktoshoulder?: number;
}

export interface AllTShirtMeasuresNumbersMandatory {
	frontlength: number;
	shouldertoshoulder: number;
	chest: number;
	waist: number;
	hem: number;
	armholeopening: number;
	neckwidth: number;
	sleeveopening: number;
	sleevelength: number;
	necktoshoulder: number;
}

export const newTeeTypesObjectEmptyOrZero = {
	newteetypes_id: 1,
	manufacturer: "",
	description: "",
	availablecolors: [],
	imageurls: {
		nocolor: [],
	},
	availablecountries: [],
	notavailablecountries: [],
	garmenttype: "t-shirt",
	yearsavailable: [],
	materials: null,
	weight: null,
	imageurlstertiary: {},
};

export const idealGarmentMeasurementsZero = {
	armholeopening: 0,
	chest: 0,
	frontlength: 0,
	hem: 0,
	necktoshoulder: 0,
	neckwidth: 0,
	shouldertoshoulder: 0,
	sleevelength: 0,
	sleeveopening: 0,
	waist: 0,
};

export const teeMeasuresAveragesObjectEmptyOrZero = {
	...idealGarmentMeasurementsZero,
	teemeasuresaverages_id: 0,
	newteetypes_id: 0,
	size: "small",
};